<template>
  <CourseBasicItem :course="certificate.course"/>
</template>

<script>
import CourseBasicItem from './CourseBasicItem.vue'

export default {
  components: {
    CourseBasicItem
  },

  props: {
    certificate: { type: Object, required: true }
  }
}
</script>
